import { rem } from '@mantine/core'
import type { Icon, IconWeight } from '@phosphor-icons/react'
import type { CSSProperties } from 'react'

export function IconGlyph({
  color,
  icon: IconComponent,
  size,
  style,
  weight = 'bold',
}: {
  color?: string
  icon: Icon
  size: number
  style?: CSSProperties
  weight?: IconWeight
}) {
  return (
    <IconComponent
      color={color}
      style={{ height: rem(size), width: rem(size), ...style }}
      weight={weight}
    />
  )
}
